import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const MegaMenu = ({ section, onClose }) => {
  if (!section) return null;

  return (
    <div
      className="absolute left-0 right-0 top-full bg-white border-t border-stone shadow-[0_24px_60px_-30px_rgba(0,0,0,0.18)]"
      data-testid={`megamenu-${section.key}`}
      onMouseLeave={onClose}
    >
      <div className="container-rozier py-10 md:py-12 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-4 flex flex-col justify-between gap-6">
          <div>
            <p className="overline mb-4" data-testid={`megamenu-overline-${section.key}`}>
              {section.label}
            </p>
            <p className="font-serif italic text-2xl md:text-3xl text-charcoal leading-snug max-w-[28ch]">
              {section.intro}
            </p>
          </div>
          <Link
            to={section.path}
            onClick={onClose}
            className="inline-flex items-center gap-3 text-charcoal hover:text-gold transition-colors duration-300 group"
            data-testid={`megamenu-cta-${section.key}`}
          >
            <span className="overline">Découvrir l'univers</span>
            <ArrowUpRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
            />
          </Link>
        </div>

        <div className="col-span-12 md:col-span-5">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
            {section.items.map((item) => (
              <li key={item.key}>
                <Link
                  to={item.path}
                  onClick={onClose}
                  className="group flex flex-col gap-1 py-2 border-b border-transparent hover:border-gold transition-colors duration-300"
                  data-testid={`megamenu-link-${item.key}`}
                >
                  <span className="font-serif text-lg text-charcoal group-hover:text-gold transition-colors">
                    {item.label}
                  </span>
                  <span className="text-xs text-graphite leading-relaxed">
                    {item.teaser}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="hidden md:block md:col-span-3">
          <div className="relative overflow-hidden aspect-[3/4]">
            <img
              src={section.image}
              alt={section.label}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <p className="text-white font-serif italic text-lg leading-tight">
                {section.label}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
